import Axios, { Response } from '../utils/Axios';

const UtilController = {
  // // 이미지 업로드
  // uploadImg: async (image: any, store_id: number, dir_key: string): Promise<Response> => {
  //   try {
  //     let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/upload`;
  //     const response: any = await Axios.multipartPost(sUrl, image, store_id, dir_key);
  //     return response;
  //   } catch (err) {
  //     let oErr: any = err;
  //     return {
  //       ok: false,
  //       msg: '[이미지 업로드 오류]' + oErr.toString(),
  //       data: undefined,
  //       status: 500,
  //     };
  //   }
  // },

  // 로고 이미지 업로드
  storeLogoUploadImg: async (image: any, store_id: number): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/logo/upload`;
      const response: any = await Axios.multipartPost(sUrl, image, store_id, 'store_logo');
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[로고 이미지 업로드 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  // 매장 이미지 업로드
  storeImageUploadImg: async (image: any, store_id: number): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/image/upload`;
      const response: any = await Axios.multipartPost(sUrl, image, store_id, 'store_image');
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[매장 이미지 업로드 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  // 상품 이미지 업로드
  productUploadImg: async (image: any, store_id: number): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/menu/product/upload`;
      const response: any = await Axios.multipartPost(sUrl, image, store_id, 'prd_img');
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[상품 이미지 업로드 오류]' + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
};
// store_logo: 로고 이미지
// store_image: 가게 이미지(매장 소개)
// product_image: 상품 이미지
// set_image: 세트메뉴 이미지
// business_registration: 사업자 등록증

export default UtilController;
